'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  cursor: pointer;\n  position: relative;\n  video, img {\n    width: 100%;\n    border: 1px solid rgba(0,0,0,.75);\n  }\n'], ['\n  cursor: pointer;\n  position: relative;\n  video, img {\n    width: 100%;\n    border: 1px solid rgba(0,0,0,.75);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: rgba(0,0,0,0.5);\n'], ['\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: rgba(0,0,0,0.5);\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Video = _styledComponents2.default.div(_templateObject);

var IconBox = _styledComponents2.default.div(_templateObject2);

/** @class VideoContent
  * Displays a video link.
  * @param {url} video - the video's url
  * @param {url} thumbnail - a url to a thumbnail image to render
  * @param {string} caption - a caption to display with the video
  */

var VideoContent = function (_Component) {
  _inherits(VideoContent, _Component);

  function VideoContent(props) {
    _classCallCheck(this, VideoContent);

    var _this = _possibleConstructorReturn(this, (VideoContent.__proto__ || Object.getPrototypeOf(VideoContent)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(VideoContent, [{
    key: 'handleClick',
    value: function handleClick(event) {
      event.preventDefault();
      if (window.vexpo && window.vexpo.overlay) window.vexpo.overlay(this.props);
    }
    /** @function
     * Renders the Video Content component.
     */

  }, {
    key: 'render',
    value: function render() {
      if (this.props.thumbnail !== undefined) {
        return _react2.default.createElement(
          Video,
          { onClick: this.handleClick },
          _react2.default.createElement('img', { src: this.props.thumbnail, alt: this.props.caption }),
          _react2.default.createElement(
            IconBox,
            null,
            _react2.default.createElement(_reactFontawesome2.default, { name: 'play-circle', size: '4x' })
          )
        );
      } else {
        return _react2.default.createElement(
          Video,
          { onClick: this.handleClick, style: { textAlign: 'center' } },
          _react2.default.createElement(_reactFontawesome2.default, { name: 'play-circle', size: '4x' }),
          _react2.default.createElement('br', null),
          this.props.caption
        );
      }
    }
  }]);

  return VideoContent;
}(_react.Component);

exports.default = VideoContent;


VideoContent.propTypes = {
  video: _propTypes2.default.string.isRequired,
  thumbnail: _propTypes2.default.string,
  caption: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/content/video-content.js
// module id = 1324
// module chunks = 0